import { render, staticRenderFns } from "./WorkflowAnnotation.vue?vue&type=template&id=19804453&scoped=true"
import script from "./WorkflowAnnotation.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowAnnotation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowAnnotation.vue?vue&type=style&index=0&id=19804453&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19804453",
  null
  
)

export default component.exports